import { licencesTypes } from 'shared/constants/licencesTypes';
import { organisationAdmin } from 'shared/constants/rolesTypes';

export const moduleRoutes = {
  [organisationAdmin]: 'sso',
  [licencesTypes.INVESTORHUB_MODULE]: 'storefront',
  [licencesTypes.ANALYTICALOPERATIONS_MODULE]: 'anop',
  [licencesTypes.RISKANALYSIS_MODULE]: 'riskanalysis',
};
